export const httpI18nKeys = {
    SuccessfullySaved: "SuccessfullySaved",
    SuccessfullyDeleted: "SuccessfullyDeleted"

}